/**
 * Calendar colours for components: the organization's state colour overrides and the colour
 * tags of the current calendar feed, resolved through calendarColors.js.
 */
import { useMemo } from 'react';

import { useUserStore } from 'store';
import {
  CALENDAR_STATE_KEYS,
  getStateConfig,
  resolveEventColors,
} from '../calendarColors';
import useCalendarState from './useCalendarState';

export default function useCalendarColors() {
  const overrides = useUserStore((s) => s.currentOrganization?.calendar_state_colors);
  const colorTags = useCalendarState((s) => s.colorTags);

  return useMemo(() => {
    const tagsById = {};
    (colorTags || []).forEach((tag) => {
      tagsById[tag.id] = tag;
    });
    // Retired tags stay resolvable so old cards keep their colour, but are never offered.
    const activeTags = (colorTags || []).filter((tag) => tag.is_active !== false);

    return {
      overrides,
      tagsById,
      activeTags,
      statusEntries: CALENDAR_STATE_KEYS.map((key) => [key, getStateConfig(key, overrides)]),
      getStateConfig: (state) => getStateConfig(state, overrides),
      resolveEvent: (event, highlighted) =>
        resolveEventColors({
          state: event?.state,
          colorTagId: event?.color_tag_id,
          overrides,
          tagsById,
          highlighted,
        }),
    };
  }, [overrides, colorTags]);
}
